/*
 * @Author: your name
 * @Date: 2020-08-18 09:33:37
 * @LastEditTime: 2020-11-12 11:03:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /dmps-console-web/src/store/index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'

import app from './module/app'
import user from './module/user'
import publisher from './module/publisher'
import dict from './module/dict'
import manuscript from './module/manuscript'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    publisher,
    dict,
    manuscript
  }
})
